<template>
  <tr
  :class="{'selected': selected[item.tempID]}">

    <td class="sticky">
      <div class="c-flex align-center">
        <v-icon 
        class="drag-handle" color="">menu</v-icon>
        <v-icon 
        @click.stop="$emit('checkRow', item)"
        :color="selected[item.tempID] ? 'color1' : ''"> 
          {{ selected[item.tempID] ? 'check_box' : 'check_box_outline_blank' }}
        </v-icon>
        <img class="c-align-self-start" src="@/assets/img/illustrations/sugar-and-cinnamon.png" alt="cardboard box" width="46px">
        <span class="ml-3" v-html="highlightedName">
        </span>
      </div>
    </td>

    <td>
      <c-input :value.sync="item.value"></c-input>

      <!-- CUSTOM AREA -->
      <c-select-currency 
      v-if="item.name === 'default_currency_code'"
      :selectedID="parseInt(item.value)" class="crx-box-input"></c-select-currency>
    </td>

  </tr>
</template>

<script>
export default {
  props: ['item', 'selected', 'searchFilters', 'selectedCount'],
  data () {
    return {
      // 8
    }
  },
  computed: {
    highlightedName () {
      if (!this.searchFilters.name) {
        return this.item.name
      }
      var replacedStr = (this.searchFilters.name || '').trim().split(/\s+/).map(x => x.replace(/[-[\]{}()*+!<=:?.\\^$|#\s,]/g, '\\$&')).join('|')
      replacedStr = this.item.name.replace(new RegExp(replacedStr, 'gi'), '<span class="font-weight-regular">$&</span>')
      return '<span class="font-weight-bold">' + replacedStr + '</span>'
    }
  }
}
</script>

<style scoped lang="scss">
.drag-handle {
  cursor: move;
}
.mrow {
  cursor: pointer;
  position: relative;
  min-height: 60px;
  border-bottom: 1px solid var(--v-hline-base);

  &:hover {
    background: #fafbfc;
  }
}
.flex-cell {
  padding: 5px;
  border-right: 1px solid var(--v-hline-base);
  display:flex;
  align-items: center;
  text-overflow: ellipsis;
  overflow: hidden;
}
.triangle {
  width: 12px;
  height: 12px;
  background: var(--v-text-base);
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  margin-left: -6px;
  margin-right: 2px;
  margin-top: 10px;
}
</style>
